import { render, staticRenderFns } from "./Mechanics.vue?vue&type=template&id=1aa51bd9&scoped=true"
import script from "./Mechanics.vue?vue&type=script&lang=ts"
export * from "./Mechanics.vue?vue&type=script&lang=ts"
import style0 from "./Mechanics.vue?vue&type=style&index=0&id=1aa51bd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa51bd9",
  null
  
)

export default component.exports